import React from 'react';

const CalendarIcon = ({ fill }: { fill: string }) => {
  return (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5016 18.1688L9.05712 15.3088L5.87934 14.0088L9.05712 12.7088L10.5016 9.84877L11.946 12.7088L15.1238 14.0088L11.946 15.3088L10.5016 18.1688ZM2.41267 21.2888C1.77712 21.2888 1.23304 21.0851 0.780451 20.6778C0.327859 20.2704 0.101562 19.7808 0.101562 19.2088V4.64877C0.101562 4.07677 0.327859 3.5871 0.780451 3.17977C1.23304 2.77244 1.77712 2.56877 2.41267 2.56877H3.56823V0.48877H5.87934V2.56877H15.1238V0.48877H17.4349V2.56877H18.5905C19.226 2.56877 19.7701 2.77244 20.2227 3.17977C20.6753 3.5871 20.9016 4.07677 20.9016 4.64877V19.2088C20.9016 19.7808 20.6753 20.2704 20.2227 20.6778C19.7701 21.0851 19.226 21.2888 18.5905 21.2888H2.41267ZM2.41267 19.2088H18.5905V8.80877H2.41267V19.2088Z"
        fill={fill}
      />
    </svg>
  );
};

export default CalendarIcon;
